import fuzzysort from '@fafm/fuzzysort';

const defaultOptions: Fuzzysort.Options = {
  allowTypo: false,
  threshold: -10000,
};
const defaultInst = fuzzysort.new(defaultOptions);

export const single = defaultInst.single.bind(defaultInst);
